import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { getUser } from '../components/Functions';
import Auth from '../components/Auth';
import Nav from '../components/Nav';
import '../css/Editllamada.css';

function EditLlamada() {
  const { id_llamada } = useParams();
  const [llamadaData, setLlamadaData] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');


  // Obtener la fecha actual en formato ISO (AAAA-MM-DD)
  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    const fetchLlamada = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/llamada/buscar?id=${id_llamada}`);
        setLlamadaData(response.data[0]);
      } catch (error) {
        console.error('Error al cargar los datos de la llamada:', error.message);
      }
    };
    fetchLlamada();
  }, [id_llamada]);

  // Validación de caracteres especiales en campos no permitidos
  const valoresEspeciales = (input) => {
    const regex = /^[a-zñA-ZÑ0-9._@ ]*$/;
    return regex.test(input);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // Si el campo no permite caracteres especiales, aplicamos la función de validación
    if (name === "nombre" || name === "apellidos" || name === "nivel_ingles" || name === "curso_interes" || name === "como_conocio" || name === "grupo_joven" || name === "trabaja" || name === "sector" || name === "comentarios" || name === "provincia" || name === "otros_comentarios") {
      if (value === "" || valoresEspeciales(value)) {
        setLlamadaData({ ...llamadaData, [name]: value.toUpperCase() });
      }
    } else {
      // Para otros campos, simplemente actualizamos el valor sin aplicar validación
      setLlamadaData({ ...llamadaData, [name]: value });
    }
  };

  // Modificar llamada con fecha y usuario automáticos
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      // Obtener el nombre de usuario del local storage y agregarlo a la llamadaData
      const datosAcceso = localStorage.getItem('datosAcceso');
      if (datosAcceso) {
        const { email } = JSON.parse(datosAcceso);
        const userData = await getUser(email);
        const updatedData = {
          ...llamadaData,
          ultima_llamada: today,
          usuario: userData?.name || '',
        };
        // Enviar la solicitud PUT con los cambios
        const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/llamada/editar/${id_llamada}`, updatedData);
        console.log(response.data);
        // Mostrar mensaje de éxito
        setSuccessMessage('Datos guardados correctamente');
        // Restablecer el mensaje de éxito después de 2 segundos
        setTimeout(() => {
          setSuccessMessage('');
        }, 2000);
        if(setSuccessMessage){
          window.location.href = '/llamadas';
        }
      }
    } catch (error) {
      console.error('Error al editar la llamada:', error.message);
      // Mostrar mensaje de error
      setErrorMessage('Error al guardar los datos');
    }
  };

  return (
    <Auth>
      {({ nombreUsuario, isAdmin, handleLogout }) => (
        <div><Nav />
          <div className='divEditllamada'>
            <h2>Editando Llamada ID: {id_llamada}</h2>
            <form onSubmit={handleFormSubmit}>
              <label >
                <input
                  type="hidden"
                  name="ultima_llamada"
                  value={today}
                  readOnly
                />
              </label>
              <label className='tituloinputEditllamada'>
                Nombre:
                <input className='inputEditllamada'
                  type="text"
                  name="nombre"
                  value={llamadaData.nombre || ""}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label className='tituloinputEditllamada'>
                apellidos:
                <input
                  className='inputEditllamada'
                  type="text"
                  name="apellidos"
                  value={llamadaData.apellidos || ""}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label className='tituloinputEditllamada'>
                telefono:
                <input className='inputEditllamada'
                  type="number"
                  pattern="[0-9]*"
                  name="telefono"
                  value={llamadaData.telefono || ""}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label className='tituloinputEditllamada'>
                mail:
                <input
                  className='inputEditllamada'
                  type="text"
                  name="mail"
                  value={llamadaData.mail || ""}
                  onChange={handleInputChange}
                />
              </label>

              <label className='tituloinputEditllamada' htmlFor="nivel_estudios">Nivel de estudios:</label>
              <select className='inputEditllamada'
                id="nivel_estudios"
                name="nivel_estudios"
                value={llamadaData.nivel_estudios || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="SIN ESTUDIOS">SIN ESTUDIOS</option>
                <option value="ESO">ESO</option>
                <option value="BACHILLER">BACHILLER</option>
                <option value="SUPERIOR">SUPERIOR</option>
              </select>

              <label className='tituloinputEditllamada' htmlFor="nivel_ingles">Nivel de inglés:</label>
              <select className='inputEditllamada'
                id="nivel_ingles"
                name="nivel_ingles"
                value={llamadaData.nivel_ingles || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="A1">A1</option>
                <option value="A2">A2</option>
                <option value="B1">B1</option>
                <option value="B2">B2</option>
                <option value="C1">C1</option>
                <option value="C2">C2</option>
              </select>

              <label className='tituloinputEditllamada' htmlFor="curso_interes">Curso de interés:</label>
              <select className='inputEditllamada'
                id="curso_interes"
                name="curso_interes"
                value={llamadaData.curso_interes || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="ADMINISTRACION">ADMINISTRACION</option>
                <option value="AGRARIO">AGRARIO</option>
                <option value="EDUCACION">EDUCACION</option>
                <option value="EMPRENDIMIENTO">EMPRENDIMIENTO</option>
                <option value="HOSTELERIA">HOSTELERIA</option>
                <option value="IDIOMAS">IDIOMAS</option>
                <option value="INFORMATICA">INFORMATICA</option>
                <option value="LOGISTICA-ALMACEN">LOGISTICA-ALMACEN</option>
                <option value="OPOSICIONES">OPOSICIONES</option>
                <option value="SANIDAD">SANIDAD</option>
                <option value="TRANSPORTE">TRANSPORTE</option>
                <option value="TURISMO">TURISMO</option>
                <option value="RESIDUOS">RESIDUOS</option>
                <option value="PSICOONCOLOGIA">PSICOONCOLOGIA</option>
                <option value="PEDIATRIA">PEDIATRIA</option>
                <option value="COMUNICACION">COMUNICACION</option>

              </select>

              <label className='tituloinputEditllamada' htmlFor="como_conocio">Como nos conocio:</label>
              <select className='inputEditllamada'
                id="como_conocio"
                name="como_conocio"
                value={llamadaData.como_conocio || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="OFICINA">OFICINA</option>
                <option value="REDES SOCIALES">REDES SOCIALES</option>
                <option value="PUBLICIDAD">PUBLICIDAD</option>
                <option value="CONOCIDO">CONOCIDO</option>
              </select>

              <label className='tituloinputEditllamada' htmlFor="grupo_joven">Grupo joven:</label>
              <select className='inputEditllamada'
                id="grupo_joven"
                name="grupo_joven"
                value={llamadaData.grupo_joven || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>

              </select>

              <label className='tituloinputEditllamada' htmlFor="trabaja">Situación laboral:</label>
              <select className='inputEditllamada'
                id="trabaja"
                name="trabaja"
                value={llamadaData.trabaja || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="DESEMPLEADO">DESEMPLEADO</option>
                <option value="OCUPADO">OCUPADO</option>
                <option value="AUTONOMO">AUTONOMO</option>
                <option value="EMPRESA">EMPRESA</option>
              </select>

              <label className='tituloinputEditllamada' htmlFor="sector">Sector de interés:</label>
              <select className='inputEditllamada'
                id="sector"
                name="sector"
                value={llamadaData.sector || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="ADMINISTRACION">ADMINISTRACION</option>
                <option value="AGRARIAS">AGRARIAS</option>
                <option value="AGUA">AGUA</option>
                <option value="ARTES GRAFICAS">ARTES GRAFICAS</option>
                <option value="AUTONOMO">AUTONOMO</option>
                <option value="COMERCIO Y MARKETING">COMERCIO Y MARKETING</option>
                <option value="DESEMPLEADO">DESEMPLEADO</option>
                <option value="EDIFICACIÓN Y OBRA CIVIL">EDIFICACIÓN Y OBRA CIVIL</option>
                <option value="EDUCACION">EDUCACION</option>
                <option value="ENERGIA">ENERGIA</option>
                <option value="HOSTELERIA Y TURISMO">HOSTELERIA Y TURISMO</option>
                <option value="IMAGEN PERSONAL">IMAGEN PERSONAL</option>
                <option value="IMAGEN Y SONIDO">IMAGEN Y SONIDO</option>
                <option value="INDUSTRIAS ALIMENTARIAS">INDUSTRIAS ALIMENTARIAS</option>
                <option value="INFORMATICA">INFORMATICA</option>
                <option value="MADERA MUEBLE Y CORCHO">MADERA MUEBLE Y CORCHO</option>
                <option value="MEDIOAMBIENTE">MEDIOAMBIENTE</option>
                <option value="METAL">METAL</option>
                <option value="QUIMICA">QUIMICA</option>
                <option value="SANIDAD">SANIDAD</option>
                <option value="SEGURIDAD">SEGURIDAD</option>
                <option value="SERVICIOS - OTROS">SERVICIOS - OTROS</option>
                <option value="SERVICIOS A LAS EMPRESAS">SERVICIOS A LAS EMPRESAS</option>
                <option value="SERVICIOS SOCIALES">SERVICIOS SOCIALES</option>
                <option value="TEXTIL CONFECCION Y PIEL">TEXTIL CONFECCION Y PIEL</option>
                <option value="TRANSPORTES">TRANSPORTES</option>
                <option value="FUNCIONARIO">FUNCIONARIO</option>
                <option value="INGENIERIA">INGENIERIA</option>
              </select>

              <label className='tituloinputEditllamada' htmlFor="comentarios">Comentarios:</label>
              <select className='inputEditllamada'
                id="comentarios"
                name="comentarios"
                value={llamadaData.comentarios || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="RESIDE EN OTRA PROVINCIA">RESIDE EN OTRA PROVINCIA</option>
                <option value="ENVIAR INFORMACION">ENVIAR INFORMACION</option>
                <option value="YA ES ALUMNO">YA ES ALUMNO</option>
                <option value="CUALEGA NO QUIERE QUE SE LE LLAME ">CUALEGA NO QUIERE QUE SE LE LLAME </option>
              </select>

              <label className='tituloinputEditllamada' htmlFor="provincia">Provincia:</label>
              <select className='inputEditllamada'
                id="provincia"
                name="provincia"
                value={llamadaData.provincia || ""}
                onChange={handleInputChange}
              >
                <option value="">SELECCIONA UNA OPCIÓN</option>
                <option value="NO FACILITA">NO FACILITA</option>
                <option value="ALBACETE">ALBACETE</option>
                <option value="ALICANTE">ALICANTE</option>
                <option value="ALMERÍA">ALMERÍA</option>
                <option value="ARABA">ARABA</option>
                <option value="ASTURIAS">ASTURIAS</option>
                <option value="AVILA">AVILA</option>
                <option value="BADAJOZ">BADAJOZ</option>
                <option value="BALEARES">BALEARES</option>
                <option value="BARCELONA">BARCELONA</option>
                <option value="BIZKAIA">BIZKAIA</option>
                <option value="BURGOS">BURGOS</option>
                <option value="CACERES">CACERES</option>
                <option value="CADIZ">CADIZ</option>
                <option value="CANTABRIA">CANTABRIA</option>
                <option value="CASTELLON">CASTELLON</option>
                <option value="CEUTA MELILLA">CEUTA MELILLA</option>
                <option value="CIUDAD REAL">CIUDAD REAL</option>
                <option value="CORDOBA">CORDOBA</option>
                <option value="CORUÑA">CORUÑA</option>
                <option value="CUENCA">CUENCA</option>
                <option value="GIPUZKOA">GIPUZKOA</option>
                <option value="GIRONA">GIRONA</option>
                <option value="GRANADA">GRANADA</option>
                <option value="GUADALAJARA">GUADALAJARA</option>
                <option value="HUELVA">HUELVA</option>
                <option value="HUESCA">HUESCA</option>
                <option value="JAEN">JAEN</option>
                <option value="LA RIOJA">LA RIOJA</option>
                <option value="LAS PALMAS">LAS PALMAS</option>
                <option value="LEON">LEON</option>
                <option value="LLEIDA">LLEIDA</option>
                <option value="LUGO">LUGO</option>
                <option value="MADRID">MADRID</option>
                <option value="MALAGA">MALAGA</option>
                <option value="MURCIA">MURCIA</option>
                <option value="NAVARRA">NAVARRA</option>
                <option value="OURENSE">OURENSE</option>
                <option value="PALENCIA">PALENCIA</option>
                <option value="PONTEVEDRA">PONTEVEDRA</option>
                <option value="SALAMANCA">SALAMANCA</option>
                <option value="SANTA CRUZ DE TENERIFE">SANTA CRUZ DE TENERIFE</option>
                <option value="SEGOVIA">SEGOVIA</option>
                <option value="SEVILLA">SEVILLA</option>
                <option value="SORIA">SORIA</option>
                <option value="TARRAGONA">TARRAGONA</option>
                <option value="TERUEL">TERUEL</option>
                <option value="TOLEDO">TOLEDO</option>
                <option value="VALENCIA">VALENCIA</option>
                <option value="VALLADOLID">VALLADOLID</option>
                <option value="ZAMORA">ZAMORA</option>
                <option value="ZARAGOZA">ZARAGOZA</option>
                <option value="EXTRANJERO">EXTRANJERO</option>
              </select>

              <label className='tituloinputEditllamada'>
                otros_comentarios:
                <textarea
                  className='inputEditllamada'
                  name="otros_comentarios"
                  value={llamadaData.otros_comentarios || ""}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                <input
                  type="hidden"
                  name="usuario"
                  value={llamadaData.usuario || ""}
                  onChange={handleInputChange}
                />
              </label>
              <button type="submit">Guardar cambios</button>
            </form>
            {successMessage && <div className="success-message">{successMessage}</div>}
            {errorMessage && <div className="error-message">{errorMessage}</div>}
          </div>
        </div>
      )}
    </Auth>
  );
}

export default EditLlamada;